import { useCallback } from 'react'

import { useMutation } from '@tanstack/react-query'
import {
  type MergeArgs,
  type LegacyMergeRequestBody,
  type MergeResponse
} from './types'
import useMapConflictSelections from 'hooks/useMapConflictSelections/useMapConflictSelections'
import { type ConflictVersion } from 'components/ConflictVersionSelector/types'
import useDesignerClient from 'api/clients/useDesignerClient'

const conflictMapping = new Map<ConflictVersion, string>([
  ['OURS', 'SOURCE'],
  ['THEIRS', 'TARGET']
])

const useLegacyMerge = () => {
  const { project, client } = useDesignerClient()
  const { map } = useMapConflictSelections(conflictMapping)

  const merge = useCallback(
    async ({
      mergeMessage,
      targetBranch,
      sourceCommitId,
      targetCommitId,
      conflictSelections
    }: MergeArgs) => {
      const body: LegacyMergeRequestBody = {
        sourceCommitId,
        targetCommitId,
        targetBranchName: targetBranch,
        commitMessage: mergeMessage,
        conflictResolutions: map(conflictSelections)
      }

      const url = `projects/${project}/merges`
      const { data } = await client.post<MergeResponse>(url, body)

      return data
    },
    [client, map, project]
  )

  return useMutation([project], merge)
}

export default useLegacyMerge
